import styled from 'styled-components';
import {
  Breadcrumbs as MatBreadcrumbs,
} from '@material-ui/core';

export const UiBreadcrumbs = styled(MatBreadcrumbs)`
	display: flex;
`;
